import React, { useContext, useEffect } from 'react';
import {
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate,
} from 'react-router-dom';

import AuthContext from '../Context/authContext';
import RequireAuth from '../Components/RequireAuth';
import { SpotNavBar } from '../Layouts/NavBar';
import LandingPage from './landing';
import BusinessPage from './business';
import LoginPage from './login';
import SignupPage from './signup';
import PasswordResetPage from './passwordreset';
import NewPasswordPage from './newpassword';
import NewSpotPage from './account/AddSpot';
import EditSpot from './account/EditSpot';
import DashBoardPage from './dashboard';
import StaffListPage from './staff/stafflist';
import AddStaffPage from './staff/addStaff';
import MenuListPage from './menu/menulist';
import AddMenu from './menu/AddMenu';
import EditMenu from './menu/EditMenu';
import WithdrawFunds from './withdrawfunds/Withdraw';
import RaverMenuList from './raverweb/menu';
import TabPage from './raverweb/tab';
import FaqPage from './faq';
import LegalPage from './termsAndPolicy';
import ContactPage from './contactus';
import TabHistory from './tab/history';

import './sharedStyles.scss';

const SpotRoutes = () => {
  return (
    <>
      <SpotNavBar />
      <Routes>
        <Route path="staff" element={<StaffListPage />} />
        <Route path="staff/new" element={<AddStaffPage />} />
        <Route path="menu" element={<MenuListPage />} />
        <Route exact path='menu/new' element={<AddMenu />} />
        <Route path='menu/:menuId' element={<EditMenu />} />
        <Route exact path='account' element={<EditSpot />} />
        <Route exact path='wallet' element={<WithdrawFunds />} />
        <Route exact path='tab-history' element={<TabHistory />} />
      </Routes>
    </>
  );
};

const ProtectedRoutes = () => {
  const { isAuthenticated } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login", { state: { from: location.pathname }});
    }
  }, [isAuthenticated, navigate, location.pathname])

  return (
    <Routes>
      <Route exact path='/spot/new' element={<RequireAuth><NewSpotPage /></RequireAuth>} />
      <Route exact path='/dashboard' element={<DashBoardPage />} />
      <Route path="/spot/:id/*" element={<SpotRoutes />} />
    </Routes>
  )
}

const RaverRoutes = () => {
  return (
    <Routes>
      <Route path="menu" element={<RaverMenuList />} />
      <Route path="tab" element={<TabPage />} />
    </Routes>
  )
}

const Pages = () => {
  const { isAuthenticated } = useContext(AuthContext);
  const location = useLocation();
  const pathName = location.state?.from || '/dashboard';

  return (
    <Routes>
      <Route exact path='/' element={<LandingPage />} />
      <Route exact path='/business' element={<BusinessPage />} />
      {
        isAuthenticated ?
          <Route path='/login' element={<Navigate to={pathName} />} /> :
          <Route exact path='/login' element={<LoginPage />} />
      }
      <Route exact path='/signup' element={<SignupPage />} />
      <Route exact path='/reset-password' element={<PasswordResetPage />} />
      <Route exact path='/newpassword/:token' element={<NewPasswordPage />} />
      <Route path = '*' element={<ProtectedRoutes />} />
      <Route path="/raver/:spotUuid/*" element={<RaverRoutes />} />
      <Route path='/faq' element={<FaqPage />} />
      <Route path='/terms-and-policies' element={<LegalPage />} />
      <Route path='/contactus' element={<ContactPage />} />
    </Routes>
  );
};

export default Pages;
